/**
 * Created by gusenlin on 2017/4/26.
 */
export function statusMap(_this) {
  return {
    1001: _this.$t('commonForm-1.key498', { cm: '提交审批' }), //提交审批
    1002: _this.$t('common.key16', { cm: '撤回' }), //撤回
    1003: _this.$t('commonForm-1.key499', { cm: '申请单更改' }), //申请单更改
    2001: _this.$t('commonForm-1.key224', { cm: '审批通过' }), //审批通过
    2002: _this.$t('commonForm-1.key500', { cm: '审批驳回' }), //审批驳回
    2003: _this.$t('commonForm-1.key501', { cm: '单笔驳回' }), //单笔驳回
    3001: _this.$t('commonForm-1.key224', { cm: '审批通过' }), //审批通过
    3002: _this.$t('commonForm-1.key349', { cm: '审核驳回' }),
    3003: _this.$t('commonForm-1.key502', { cm: '财务已收单' }),
    3004: _this.$t('commonForm-1.key503', { cm: 'BPO预检通过' }),
    3006: _this.$t('commonForm-1.key504', { cm: '财务通知' }),
    3007: _this.$t('commonForm-1.key505', { cm: '寄单成功' }),
    4000: _this.$t('commonForm-1.key351', { cm: '付款中' }),
    4001: _this.$t('commonForm-1.key342', { cm: '已付款' }),
    4002: _this.$t('commonForm-1.key506', { cm: '付款失败' }),
    4011: _this.$t('commonForm-1.key507', { cm: '财务已开票' }),
    4012: _this.$t('common.key114', { cm: '驳回' }),
    5000: _this.$t('commonForm-1.key508', { cm: 'APP还款提交' }),
    5001: _this.$t('commonForm-1.key509', { cm: '现金还款提交' }),
    5002: _this.$t('commonForm-1.key510', { cm: '收款通过' }),
    5003: _this.$t('commonForm-1.key511', { cm: '收款驳回' }),
    5004: _this.$t('commonForm-1.key512', { cm: '报销单还款提交' }),
    5005: _this.$t('commonForm-1.key513', { cm: '申请单关闭' }),
    5006: _this.$t('commonForm-1.key514', { cm: '关闭申请单' }),
    5007: _this.$t('commonForm-1.key515', { cm: '重启申请单' }),
    5008: _this.$t('commonForm-1.key516', { cm: '统一停用' }),
    5009: _this.$t('commonForm-1.key232', { cm: '加签' }),
    6001: _this.$t('commonForm-1.key517', { cm: '发起机票信息确认' }),
    6002: _this.$t('commonForm-1.key518', { cm: '确认信息合适' }),
    6003: _this.$t('commonForm-1.key519', { cm: '确认机票不合适' }),
    6004: _this.$t('commonForm-1.key520', { cm: '发起机票价格审核' }),
    6005: _this.$t('commonForm-1.key521', { cm: '价格审核通过' }),
    6006: _this.$t('commonForm-1.key522', { cm: '价格审核驳回' }),
    6007: _this.$t('commonForm-1.key523', { cm: '发起改签' }),
    6008: _this.$t('commonForm-1.key524', { cm: '发起退票' }),
    6009: _this.$t('commonForm-1.key525', { cm: '完成改签' }),
    6010: _this.$t('commonForm-1.key526', { cm: '完成退票' }),
    6011: _this.$t('commonForm-1.key527', { cm: '完成订票' }),
    6012: _this.$t('commonForm-1.key528', { cm: '审批通过 需要价格审核' }),
    7001: _this.$t('commonForm-1.key529', { cm: '核定金额修改' }),
    7002: _this.$t('commonForm-1.key530', { cm: '核定汇率修改' }),
    7003: _this.$t('commonForm-1.key531', { cm: '核定金额和汇率修改' }),
    3005: _this.$t('commonForm-1.key532', { cm: '退回' }),
    8001: _this.$t('commonForm-1.key533', { cm: '员工回复' }),
    2010: _this.$t('commonForm-1.key534', { cm: '审批通知' }),
    2011: _this.$t('commonForm-1.key535', { cm: '回复' }),
  };
}

export function operationType(_this) {
  return {
    1001: '',
    1002: '',
    1003: _this.$t('commonForm-1.key536', { cm: '财务' }),
    1004: _this.$t('commonForm-1.key537', { cm: '滴滴金额' }),
    1005: _this.$t('commonForm-1.key538', { cm: '还款财务审批' }),
    1006: _this.$t('commonForm-1.key539', { cm: '系统' }),
  };
}

export function ticketStatus() {
  return {
    '-1': '未知',
    1: '待使用',
    2: '已使用',
    3: '已办理登记',
    4: '已离港',
    5: '已作废',
    6: '已退票',
    7: '已改签',
    8: '延误',
    9: '机场控制',
    10: '机场控制',
    11: '未查到',
  };
}
